export const INDUSTRIES = [
  "Healthcare",
  "Agriculture",
  "Financial Services",
  "​Industrial Goods",
  "Oil and Gas",
  "Education",
  "Tourism",
  "Mining",
  "Public service",
  "Construction/Real Estate",
  "​Information & Communications Technology",
  "​​Consumer Goods",
  "​Natural Resources",
  "Services",
  "Utilities",
  "Conglomerates",
  "Nonprofit / NGO",
  "Retail / E-commerce",
  "Media & Entertainment",
  "Transportation & Logistics",
  "Technology / Software / SaaS",
  "Legal Services"
];
export const SUBSCRIPTIONCLIENTS = ["ATB", "Leadway", "KniteIndustry"];
export const SUBSCRIPTIONPRODUCT = ["IT", "Health", "Agriculture"];
export const SUBSCRIPTIONFREQUENCY = [
  {
    value: "monthly",
    key: "month",
  },
  {
    value: "quarterly",
    key: "quarter",
  },
  {
    value: "annually",
    key: "annual",
  },
];
export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const YEAR = [
  "2040",
  "2039",
  "2038",
  "2037",
  "2036",
  "2035",
  "2034",
  "2033",
  "2032",
  "2031",
  "2030",
  "2029",
  "2028",
  "2027",
  "2026",
  "2025",
  "2024",
  "2023",
  "2022",
  "2021",
  "2020",
  "2019",
  "2018",
  "2017",
  "2016",
  "2015",
  "2014",
  "2013",
  "2012",
  "2011",
  "2010",
];
export const dataList = [
  { id: "8767567", name: "IT" },
  { id: "9097", name: "Agriculture" },
  { id: "775", name: "Health" },
];

export const ALL_INDUSTRIESSS = [
  "Abortion Policy/Anti-Abortion",
  "Abortion Policy/Pro-Abortion Rights",
  "Accountants",
  "Advertising/Public Relations",
  "Aerospace, Defense Contractors",
  "Agribusiness",
  "Agricultural Services & Products",
  "Agriculture",
  "Air Transport",
  "Air Transport Unions",
  "Airlines",
  "Alcoholic Beverages",
  "Alternative Energy Production & Services",
  "Architectural Services",
  "Attorneys/Law Firms",
  "Auto Dealers",
  "Auto Dealers, Japanese",
  "Auto Manufacturers",
  "Automotive",

  "Banking, Mortgage",
  "Banks, Commercial",
  "Banks, Savings & Loans",
  "Bars & Restaurants",
  "Beer, Wine & Liquor",
  "Books, Magazines & Newspapers",
  "Broadcasters, Radio/TV",
  "Builders/General Contractors",
  "Builders/Residential",
  "Building Materials & Equipment",
  "Building Trade Unions",
  "Business Associations",
  "Business Services",

  "Cable & Satellite TV Production & Distribution",
  "Candidate Committees",
  "Candidate Committees, Democratic",
  "Candidate Committees, Republican",
  "Car Dealers",
  "Car Dealers, Imports",
  "Car Manufacturers",
  "Casinos / Gambling",
  "Cattle Ranchers/Livestock",
  "Chemical & Related Manufacturing",
  "Chiropractors",
  "Civil Servants/Public Officials",
  "Clergy & Religious Organizations",
  "Clothing Manufacturing",
  "Coal Mining",
  "Colleges, Universities & Schools",
  "Commercial Banks",
  "Commercial TV & Radio Stations",
  "Communications/Electronics",
  "Computer Software",
  "Conservative/Republican",
  "Construction",
  "Construction Services",
  "Construction Unions",
  "Credit Unions",
  "Crop Production & Basic Processing",
  "Cruise Lines",
  "Cruise Ships & Lines",

  "Dairy",
  "Defense",
  "Defense Aerospace",
  "Defense Electronics",
  "Defense/Foreign Policy Advocates",
  "Democratic Candidate Committees",
  "Democratic Leadership PACs",
  "Democratic/Liberal",
  "Dentists",
  "Doctors & Other Health Professionals",
  "Drug Manufacturers",

  "Education",
  "Electric Utilities",
  "Electronics Manufacturing & Equipment",
  "Electronics, Defense Contractors",
  "Energy & Natural Resources",
  "Entertainment Industry",
  "Environment",

  "Farm Bureaus",
  "Farming",
  "Finance / Credit Companies",
  "Finance, Insurance & Real Estate",
  "Food & Beverage",
  "Food Processing & Sales",
  "Food Products Manufacturing",
  "Food Stores",
  "For-profit Education",
  "For-profit Prisons",
  "Foreign & Defense Policy",
  "Forestry & Forest Products",
  "Foundations, Philanthropists & Non-Profits",
  "Funeral Services",

  "Gambling & Casinos",
  "Gambling, Indian Casinos",
  "Garbage Collection/Waste Management",
  "Gas & Oil",
  "Gay & Lesbian Rights & Issues",
  "General Contractors",
  "Government Employee Unions",
  "Government Employees",
  "Gun Control",
  "Gun Rights",

  "Health",
  "Health Professionals",
  "Health Services/HMOs",
  "Hedge Funds",
  "HMOs & Health Care Services",
  "Home Builders",
  "Hospitals & Nursing Homes",
  "Hotels, Motels & Tourism",
  "Human Rights",

  "Ideological/Single-Issue",
  "Indian Gaming",
  "Industrial Unions",
  "Insurance",
  "Internet",
  "Israel Policy",

  "Labor",
  "Lawyers & Lobbyists",
  "Lawyers / Law Firms",
  "Leadership PACs",
  "Liberal/Democratic",
  "Liquor, Wine & Beer",
  "Livestock",
  "Lobbyists",
  "Lodging / Tourism",
  "Logging, Timber & Paper Mills",

  "Manufacturing, Misc",
  "Marine Transport",
  "Meat processing & products",
  "Medical Supplies",
  "Mining",
  "Misc Business",
  "Misc Finance",
  "Misc Manufacturing & Distributing",
  "Misc Unions",
  "Miscellaneous Defense",
  "Miscellaneous Services",
  "Mortgage Bankers & Brokers",
  "Motion Picture Production & Distribution",
  "Music Production",

  "Natural Gas Pipelines",
  "Newspaper, Magazine & Book Publishing",
  "Non-profits, Foundations & Philanthropists",
  "Nurses",
  "Nursing Homes/Hospitals",
  "Nutritional & Dietary Supplements",

  "Oil & Gas",
  "Other",

  "Payday Lenders",
  "Pharmaceutical Manufacturing",
  "Pharmaceuticals / Health Products",
  "Phone Companies",
  "Physicians & Other Health Professionals",
  "Postal Unions",
  "Poultry & Eggs",
  "Power Utilities",
  "Printing & Publishing",
  "Private Equity & Investment Firms",
  "Pro-Israel",
  "Professional Sports, Sports Arenas & Related Equipment & Services",
  "Progressive/Democratic",
  "Public Employees",
  "Public Sector Unions",
  "Publishing & Printing",

  "Radio/TV Stations",
  "Railroads",
  "Real Estate",
  "Record Companies/Singers",
  "Recorded Music & Music Production",
  "Recreation / Live Entertainment",
  "Religious Organizations/Clergy",
  "Republican Candidate Committees",
  "Republican Leadership PACs",
  "Republican/Conservative",
  "Residential Construction",
  "Restaurants & Drinking Establishments",
  "Retail Sales",
  "Retired",

  "Savings & Loans",
  "Schools/Education",
  "Sea Transport",
  "Securities & Investment",
  "Special Trade Contractors",
  "Sports, Professional",
  "Steel Production",
  "Stock Brokers/Investment Industry",
  "Student Loan Companies",
  "Sugar Cane & Sugar Beets",

  "Teachers Unions",
  "Teachers/Education",
  "Telecom Services & Equipment",
  "Telephone Utilities",
  "Textiles",
  "Timber, Logging & Paper Mills",
  "Tobacco",
  "Transportation",
  "Transportation Unions",
  "Trash Collection/Waste Management",
  "Trucking",
  "TV / Movies / Music",
  "TV Production",

  "Unions",
  "Unions, Airline",
  "Unions, Building Trades",
  "Unions, Industrial",
  "Unions, Misc",
  "Unions, Public Sector",
  "Unions, Teacher",
  "Unions, Transportation",
  "Universities, Colleges & Schools",

  "Vegetables & Fruits",
  "Venture Capital",

  "Waste Management",
  "Wine, Beer & Liquor",
  "Women's Issues"
]